import { iGlobalContext } from "../../context/globalContext/interface";

// Resolve a backend appConfig row to a strict boolean. Tolerates the
// multiple boolean serializations the backend may emit:
//   - native `true`
//   - the string "true" (any case) — most common today
//   - the string "1" — occasionally seen on legacy keys
// Anything else (including absent rows) is treated as `false`.
//
// Originally inlined in `hotelLocationInputField.tsx` for the
// USE_HOTEL_SEARCH_V2 / HOTEL_SEARCH_POC flags; lifted out here so any
// other surface gating on appConfig can reuse the same parsing rules.
// The hotel-search call site re-imports from here.
export function resolveBoolFlag(
  appConfig: iGlobalContext["appConfig"],
  key: string
): boolean {
  const row = appConfig?.find((item) => item.key === key);
  const raw: any = row?.value;
  if (raw === true) return true;
  if (typeof raw === "string" && ["true", "1"].includes(raw.trim().toLowerCase())) return true;
  return false;
}
